import Vue from 'vue';
import Vuetify from 'vuetify/lib';
// import VImageInput from 'vuetify-image-input';

Vue.use(Vuetify);

export default new Vuetify({
});
